import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SearchContainer} from '../../../core/definitions/search-container';

@Component({
    selector: 'app-side-menu-toggle',
    templateUrl: './side-menu-toggle.component.html',
    styleUrls: ['./side-menu-toggle.component.scss'],
    standalone: false
})
export class SideMenuToggleComponent {
  @Input() searchContainer: SearchContainer;
  @Input() sideMenuSmallScreen;
  @Output() filterSideMenuSmallScreenToggled = new EventEmitter<object>();

  toggleSideFilterMenuSmallScreen() {
    this.filterSideMenuSmallScreenToggled.emit();
  }
}
